import { useTranslation } from '@pancakeswap/localization'
import Link from 'next/link'
import { TooltipBase } from '@/components/tooltips/base'

export const TradingFeeTooltip = ({ isMM }: { isMM: boolean }) => {
  const { t } = useTranslation()

  return (
    <TooltipBase>
      <div className={'text-xs'}>
        <div className="font-bold inline-block">{t('AMM')}</div>:{' '}
        {t(
          'Fee ranging from 0.1% to 0.01% depending on the pool fee tier. You can check the fee tier by clicking the magnifier icon under the “Route” section.',
        )}
      </div>
      <div className={'text-xs'}>
        <Link
          className={'ml-1'}
          href={
            isMM
              ? 'https://docs.pancakeswap.finance/products/pancakeswap-exchange/market-maker-integration#fees'
              : 'https://docs.pancakeswap.finance/products/pancakeswap-exchange/faq#what-will-be-the-trading-fee-breakdown-for-v3-exchange'
          }
        >
          {t('Fee Breakdown and Tokenomics')}
        </Link>
      </div>
      <div className={'mt-2'}>
        <div className="font-bold inline-block">{t('MM')}</div>: :{' '}
        {t(
          'PancakeSwap does not charge any fees for trades. However, the market makers charge an implied fee of 0.05% - 0.25% (non-stablecoin) / 0.01% (stablecoin) factored into the quotes provided by them.',
        )}
      </div>
    </TooltipBase>
  )
}
